// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"104c887e","627":"5069ab45","738":"d32a29e2","923":"6fc9c67d"}[chunkId] + ".chunk.js";
};